import { COVER_CROP_MIX_TYPE, SOIL_SIGHT_TILLAGE } from "consts";

import { CropYear } from "pages/app/scenario-analysis/types/scenario";

/**
 * When a crop lands on a row, any unset practice gets residue "Removed", tillage "Conventional",
 * cover crop "None"; already-set values are kept. Crop-driven residue locks still win — run
 * `reconcileYearsResidueLocks` afterwards.
 */
export const applyPracticeDefaults = (year: CropYear): CropYear => {
  if (!year.crop?.trim()) {
    return year;
  }

  return {
    ...year,
    residue: year.residue ?? false,
    tillageId: year.tillageId ?? SOIL_SIGHT_TILLAGE.CONVENTIONAL,
    coverCropId: year.coverCropId ?? COVER_CROP_MIX_TYPE.NONE,
  };
};
